import request from '@/axios/request.js'

// 秒杀产品时间区间
export function seckillTime () {
    return request({
        url: '/mall/seckill/index',
        method: 'get'
    })
}

// 获取秒杀产品列表
export function seckillList (time, params) {
    // {
    //     'limit': 10,
    //     'page': 1
    // }
    return request({
        url: `/mall/seckill/list/${time}`,
        method: 'get',
        params
    })
}

// 秒杀产品详情
export function getSeckillItem (id) {
    return request({
        url: `/mall/seckill/detail/${id}`,
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/seckill.js